var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.qrCode)?_c('div',{staticClass:"qr-code"},[_c('img',{attrs:{"src":_vm.qrCode,"s-id":_vm.sId}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }